import { AnyAction, Reducer } from "redux";
import { ILatencyTestResults } from "../models/hubs/AuctionsHub";

export interface IDebugStoreState {}
export type KnownAction = IReceiveLatencyTestResults;

export interface IReceiveLatencyTestResults {
    type: "RECEIVE_LATENCY_TEST_RESULTS";
    testResults: ILatencyTestResults;
}

export const reducer: Reducer<IDebugStoreState> = (
    state: IDebugStoreState | undefined,
    incomingAction: AnyAction
) => {
    const action = incomingAction as KnownAction;
    const prevState = state || defaultState;

    if (action.type === "RECEIVE_LATENCY_TEST_RESULTS") {
        const now = Date.now();

        const latencyTo =
            Date.parse(action.testResults.processedTime) -
            Date.parse(action.testResults.startTime);
        const latencyFrom = now - Date.parse(action.testResults.processedTime);
        const latencyTotal = now - Date.parse(action.testResults.startTime);

        console.log("Received Latency Test Results...");
        console.log(
            `Latency To: ${latencyTo}ms, Latency From: ${latencyFrom}ms`
        );
        console.log(`Latency Round Trip: ${latencyTotal}ms`);
        console.log("-------------");
    }

    return prevState;
};

export const defaultState = {} as IDebugStoreState;
